module.exports = __webpack_public_path__ + "static/media/map.ed8d17a0.svg";